import React, {ReactNode} from 'react';

const NotificationContext = React.createContext<{
  displayNotification: (type: 'error' | 'default', title: string, subtitle: string, icon?: ReactNode) => void
}>({
  displayNotification: (title, subtitle, icon, type) => {},
});

export default NotificationContext;